/**
 * Created by tmorone on 2/17/2016.
 */

/**
 * Finds the element containing the swf
 * @returns swf object
 */
global.getSWF = function () {
    var swf = document.getElementById('swfContainer');
    return swf;
};

/**
 * Used when Facebook hides Flash to show dialogs, such as Payment
 *
 * @param info  takes 'state' to determine if flash content div is to be hidden or shown
 *
 */

global.onFlashHide = function(info) {
    if(info.state == 'opened') {
        getSWF().style.visibility = 'hidden';
    } else {
        getSWF().style.visibility = 'visible';
    }
};